import { fetchJson } from '@nubank/www-latam-commons/utils/http';

export const CARD_RATES = 'https://dadosabertos.nubank.com.br/taxasCartoes/itens';

export const createExchange = repository => (
  async () => {
    const data = await repository.fetch(CARD_RATES);
    return data.historicoTaxas;
  }
);

export default createExchange({
  fetch: fetchJson,
});
